var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.95d61f35ca94c7afa5c119cf4b1cdb10.svg#D';
                    var viewUrl = 'sprites.95d61f35ca94c7afa5c119cf4b1cdb10.svg#view-D';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };